/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useParams,Link } from 'react-router-dom';
import axios from "axios";

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import ShowBigSizePhoto from "../../../components/popups/ShowBigSizePhoto";
import { isObjEmpty,isNull,ChangeSimpleDateString,unescapeHtml,ChangeMobileFormat,SetBasePageStatus } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

import nocholdrenInage from "../../../img/sub/profile.jpg";

const MemberDetail = () => {
  const { mem_idx } = useParams();
  
  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //학부모 정보
  const [varMemberInfo,setMemberInfo] = useState({});
  //원생 배열
  const [varChildrenList,setChildrenList] = useState([]);

  //회원정보 읽어오기
  const getMemberInformation = async () => {
    const sendData = {mem_idx:Number(mem_idx)};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_parent_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          let dataInfo = datas.results[0];
          let addr = dataInfo.mem_addr1;
          if(!isNull(dataInfo.mem_addr2)) addr += ' '+dataInfo.mem_addr2;
          dataInfo['address'] = addr;
          setMemberInfo(dataInfo);

          setChildrenList(datas.childrens);
        }
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'MEMBER',item:'Members'});
    console.log(varAdminMenus);
    getMemberInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //원생사진호출
  const [varChildrenData,setChildrenData] = useState({});
  const [varOpenBigPhoto,setOpenBigPhoto] = useState(false);
  const onShowChildrenPhotHandler = (e,ch_idx) => {
    const childData = varChildrenList.find(el=>el.ch_idx === ch_idx);
    if(childData.ch_image > 0 && !isNull(childData.ch_file)) {
      setChildrenData(childData);
      SetBasePageStatus(true);
      setOpenBigPhoto(true);
    }
  }
  //팝업창 닫기
  const CloseBigPhoto = () => {
    SetBasePageStatus(false);
    setOpenBigPhoto(false);
  }

  return (
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={'학부모/원생 관리'} varDirection={'학부모/원생 관리'}/>
      {isObjEmpty(varMemberInfo)?null:
        <div className="admin-content">
          <h1 className="subtitle">- 학부모 정보</h1>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="40%"/><col width="60%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr><th>센터명</th><td>{varMemberInfo.bh_company}</td></tr>
                <tr><th>학부모명</th><td>{varMemberInfo.mem_name}</td></tr>
                <tr><th>계정</th><td>{varMemberInfo.mem_id}</td></tr>
                <tr><th>휴대폰번호</th><td>{ChangeMobileFormat(varMemberInfo.mem_mobile)}</td></tr>
                <tr><th>긴급연락처</th><td>{ChangeMobileFormat(varMemberInfo.mem_emergency)}</td></tr>
                <tr><th>주소</th><td>{varMemberInfo.address}</td></tr>
                <tr><th>상담일</th><td>{ChangeSimpleDateString(varMemberInfo.mem_consult_date)}</td></tr>
                <tr><th>등록일</th><td>{ChangeSimpleDateString(varMemberInfo.mem_rdate)}</td></tr>
                <tr><th>상담메모</th><td>{unescapeHtml(varMemberInfo.mem_consult_memo)}</td></tr>
              </tbody>
            </table>
          </div>
          <h1 className="subtitle">- 원생 정보</h1>
          <div style={{display:"flex",flexDirection:"row"}}>
            {varChildrenList.map((child,i)=>(
              <table key={'child_'+i} className="write" style={{width:"32%",border:"solid 1px #eee"}}>
                <colgroup><col width="40%"/><col width="60%"/></colgroup>
                <thead></thead>
                <tbody>
                  <tr><th>구분</th><td>{varChildrenList.length===1?"1자녀":"다자녀"}</td></tr>
                  <tr><th>원생명</th><td>{child.ch_name}</td></tr>
                  <tr><th>생년월일</th><td>{ChangeSimpleDateString(child.ch_birthday)}</td></tr>
                  <tr><th>발달기록</th><td>{unescapeHtml(child.ch_history)}</td></tr>
                  <tr><th>사진</th>
                    <td>
                      {child.vh_image===0||isNull(child.ch_file)?<img src={nocholdrenInage} alt="" />
                      :<img src={`${process.env.REACT_APP_HOST}/member/${child.ch_file}`} alt="" onClick={e=>onShowChildrenPhotHandler(e,child.ch_idx)}/>
                      }
                    </td>
                  </tr>
                  <tr><th>원생메모</th><td>{child.ch_memo}</td></tr>
                  <tr><th>레벨</th><td>{child.vl_name}</td></tr>
                </tbody>
              </table>
            ))}
          </div>
        </div>
      }
      <div className="btn-center">
        <Link to={`/Admin/MemberList`} className="btn line black">목록</Link>
      </div>
      {varOpenBigPhoto && <ShowBigSizePhoto varOpenBigPhoto={varOpenBigPhoto} varChildrenData={varChildrenData} CloseBigPhoto={CloseBigPhoto}/>}
    </div>
  );
}
export default MemberDetail;